var MAC_COMMAND = 'Meta';
var CONTROL = 'Control';
var SHIFT = 'Shift';
var ENTER = 'Enter';
var KEYCODES = {
  MAC_COMMAND: MAC_COMMAND,
  CONTROL: CONTROL,
  SHIFT: SHIFT,
  ENTER: ENTER
};
export default KEYCODES;